import React from 'react';
import { Link } from 'react-router-dom';
import { FiClock, FiStar, FiUsers, FiArrowRight } from 'react-icons/fi';

const categoryColors = {
  Development: { bg: '#dbeafe', color: '#1d4ed8' },
  'Data Science': { bg: '#f3e8ff', color: '#7c3aed' },
  Marketing: { bg: '#fef3c7', color: '#b45309' },
};

const CourseCard = ({ course }) => {
  const catStyle = categoryColors[course.category] || categoryColors.Development;

  return (
    <div className="course-card">
      <style>{`
        .course-card {
          background: white; border-radius: var(--radius-xl); overflow: hidden;
          box-shadow: var(--shadow-md); transition: var(--transition);
          border: 1px solid var(--border); display: flex; flex-direction: column;
        }
        .course-card:hover { transform: translateY(-6px); box-shadow: var(--shadow-lg); }
        .course-card-header { padding: 28px 28px 20px; background: linear-gradient(135deg, #f0f4ff, #fafbff); position: relative; }
        .course-badge-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
        .course-icon { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 26px; }
        .course-card-body { padding: 20px 28px 24px; flex: 1; display: flex; flex-direction: column; }
        .course-title { font-size: 18px; font-weight: 700; color: var(--dark); margin-bottom: 6px; line-height: 1.3; }
        .course-subtitle { font-size: 13px; color: var(--mid); margin-bottom: 14px; line-height: 1.5; }
        .course-meta { display: flex; gap: 16px; margin-bottom: 16px; }
        .course-meta-item { display: flex; align-items: center; gap: 5px; font-size: 13px; color: var(--mid); }
        .course-meta-item svg { color: var(--accent); }
        .course-highlights { list-style: none; margin-bottom: 20px; flex: 1; }
        .course-highlights li { font-size: 13px; color: var(--dark-3); padding: 4px 0; display: flex; align-items: center; gap: 8px; }
        .course-highlights li::before { content: '✓'; color: var(--success); font-weight: 700; font-size: 12px; flex-shrink: 0; }
        .course-card-footer { border-top: 1px solid var(--border); padding: 16px 28px; display: flex; align-items: center; justify-content: space-between; }
        .course-fee { }
        .course-fee-label { font-size: 11px; color: var(--mid); text-transform: uppercase; letter-spacing: 0.5px; }
        .course-fee-amount { font-size: 20px; font-weight: 800; color: var(--dark); font-family: var(--font-display); }
        .course-fee-reg { font-size: 12px; color: var(--success); font-weight: 500; margin-top: 1px; }
        .course-apply-btn { display: inline-flex; align-items: center; gap: 6px; background: var(--primary); color: white; padding: 10px 20px; border-radius: var(--radius); font-size: 14px; font-weight: 600; font-family: var(--font-display); transition: var(--transition); }
        .course-apply-btn:hover { background: var(--accent); transform: translateX(2px); }
      `}</style>

      <div className="course-card-header">
        <div className="course-badge-row">
          <div className="course-icon" style={{ background: catStyle.bg }}>
            {course.category === 'Development' ? '💻' : course.category === 'Data Science' ? '🤖' : '📱'}
          </div>
          <span className="badge" style={{ background: catStyle.bg, color: catStyle.color }}>{course.badge || course.category}</span>
        </div>
        <div style={{ fontSize: 13, color: 'var(--mid)', fontWeight: 500 }}>{course.category}</div>
      </div>

      <div className="course-card-body">
        <h3 className="course-title">{course.title}</h3>
        <p className="course-subtitle">{course.subtitle}</p>

        <div className="course-meta">
          <div className="course-meta-item"><FiClock size={13} /> {course.duration}</div>
          <div className="course-meta-item"><FiStar size={13} /> {course.rating}</div>
          <div className="course-meta-item"><FiUsers size={13} /> {course.enrolledCount}+ enrolled</div>
        </div>

        <ul className="course-highlights">
          {(course.highlights || []).slice(0, 4).map((h, i) => <li key={i}>{h}</li>)}
        </ul>

        <div className="course-card-footer" style={{ padding: '16px 0 0', borderTop: '1px solid var(--border)', marginTop: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div className="course-fee">
            <div className="course-fee-label">Program Fee</div>
            <div className="course-fee-amount">₹{course.fee?.total?.toLocaleString()}</div>
            <div className="course-fee-reg">Starts at ₹{course.fee?.registration?.toLocaleString()} registration</div>
          </div>
          <Link to={`/courses/${course.slug}`} className="course-apply-btn">
            Explore <FiArrowRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
